import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Select,
} from "antd";
import dayjs from "dayjs";

import { useState } from "react";
import { DATE_FORMAT, DEFAULT_TIME_VALUE, TIME_FORMAT } from "$utils";
import { useCreateBooking } from "$api/client";
import TextArea from "antd/es/input/TextArea";

const BookSlot = ({ locationId, timeSlots, locationSlot }) => {
  const [slot, setSlot] = useState(locationSlot ?? "");
  const [selectedDate, setSelectedDate] = useState(
    locationSlot?.date ? dayjs(locationSlot.date) : dayjs()
  );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const createBooking = useCreateBooking(locationId);

  const showModal = () => {
    if (locationId) {
      setIsModalVisible(true);
    } else {
      notification.info({ message: "Wählen Sie ein Standort aus!" });
    }
  };

  const onFinish = () => {
    const fields = form.getFieldsValue();
    fields["crm_dealercode"] = slot.crm_dealercode;
    fields["team"] = slot.team;
    fields["location_id"] = slot.location_id;
    createBooking.mutate(fields);

    form.resetFields();
    form.setFieldValue("timePicker", DEFAULT_TIME_VALUE);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onDateChange = (date) => {
    setSelectedDate(date.tz());
  };

  const onTimeChange = (slot, option) => {
    setSlot(option.slot);
  };

  let availableSlots = [];

  if (selectedDate && timeSlots && isModalVisible) {
    let slots = timeSlots[selectedDate.format(DATE_FORMAT)];
    if (slots) {
      availableSlots = slots
        .map((value) => {
          if (!value.booked) {
            return {
              title: dayjs(value.date).format(TIME_FORMAT),
              value: dayjs(value.date).format(TIME_FORMAT),
              slot: value,
            };
          }
          return null;
        })
        .filter((value) => value);
    }
  }

  let time = "";
  if (locationSlot) {
    time = dayjs(locationSlot.date).format(TIME_FORMAT);
  }
  return (
    <>
      {locationSlot ? (
        <Button
          type="link"
          onClick={showModal}
          style={{ marginBottom: "-40px" }}
        >
          {time}
        </Button>
      ) : (
        <Button type="primary" onClick={showModal}>
          Zeitslot buchen
        </Button>
      )}
      {isModalVisible && (
        <Modal
          title="Zeitslotbuchung"
          open={isModalVisible}
          onCancel={handleCancel}
          width={460}
          footer={[
            <Button
              key="saveAppointment"
              form={`bookTermin~${locationSlot?.crm_dealercode}~${locationSlot?.date}~${locationSlot?.team}`}
              type="primary"
              size="large"
              htmlType="submit"
            >
              Speichern
            </Button>,
            <Button key="cancelBookTermin" size="large" onClick={handleCancel}>
              Abbrechen
            </Button>,
          ]}
        >
          <Form
            name={`bookTermin~${locationSlot?.crm_dealercode}~${locationSlot?.date}~${locationSlot?.team}`}
            form={form}
            onFinish={onFinish}
            layout="vertical"
          >
            <div style={{ marginBottom: "20px" }}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Autokennzeichen kann nicht leer sein!",
                  },
                ]}
                name="license_plate"
                label="Kennzeichen"
              >
                <Input size="large" placeholder="Autokennzeichen" />
              </Form.Item>
            </div>
            <div className="timepickers">
              <Form.Item
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Datum kann nicht leer sein!",
                  },
                ]}
                name="datePicker"
                initialValue={
                  locationSlot ? dayjs(locationSlot.date) : dayjs().tz()
                }
                label="Datum"
              >
                <DatePicker
                  size="large"
                  onChange={onDateChange}
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Uhrzeit kann nicht leer sein!",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value === DEFAULT_TIME_VALUE) {
                        return Promise.reject(
                          "Uhrzeit kann nicht leer oder ungültig sein!"
                        );
                      }
                      return Promise.resolve();
                    },
                    validateTrigger: "onSubmit",
                  },
                ]}
                name="timePicker"
                initialValue={
                  locationSlot?.date
                    ? dayjs(locationSlot.date).format(TIME_FORMAT)
                    : DEFAULT_TIME_VALUE
                }
                label="Zeitslot"
              >
                <Select
                  key={selectedDate}
                  size="large"
                  options={availableSlots}
                  onChange={onTimeChange}
                />
              </Form.Item>

              <Form.Item style={{ width: "100%" }} label="Bühne">
                <Input
                  key={slot}
                  placeholder="Bühne"
                  size="large"
                  disabled
                  value={slot.team}
                />
              </Form.Item>
            </div>

            <div className="timepickers">
              <Form.Item
                style={{ width: "100%" }}
                name="first_name"
                label="Vorname"
              >
                <Input placeholder="Vorname" size="large" />
              </Form.Item>
              <Form.Item
                style={{ width: "100%" }}
                name="last_name"
                label="Nachname"
              >
                <Input placeholder="Nachname" size="large" />
              </Form.Item>
            </div>

            <div className="timepickers">
              <Form.Item
                style={{ width: "100%" }}
                name="phone"
                label="Telefonnummer"
              >
                <Input placeholder="Telefonnummer" size="large" />
              </Form.Item>
            </div>

            {/* <Space.Compact style={{ marginBottom: "20px" }}>
              <Form.Item
                style={{ width: "20%" }}
                rules={[
                  {
                    required: true,
                    message: "Vorwahlnummer kann nicht leer sein!",
                  },
                ]}
                name="natCode"
                initialValue={49}
              >
                <Input prefix={"+"} count={count(3)} required />
              </Form.Item>
              <Form.Item
                style={{ width: "20%" }}
                rules={[
                  {
                    required: true,
                    message: "Anbieternummer kann nicht leer sein!",
                  },
                ]}
                name="prefixCode"
              >
                <Input count={count(3)} />
              </Form.Item>
              <Form.Item
                style={{ width: "60%" }}
                rules={[
                  { required: true, message: "Nummer kann nicht leer sein!" },
                ]}
                name="number"
              >
                <Input count={count(8)} />
              </Form.Item>
            </Space.Compact> */}

            <div className="timepickers">
              <Form.Item
                style={{ width: "100%" }}
                name="email"
                label="E-Mail-Adresse"
              >
                <Input placeholder="E-Mail-Adresse" size="large" />
              </Form.Item>
            </div>

            <div className="timepickers">
              <Form.Item
                style={{ width: "100%" }}
                rules={[{ required: true, message: "Wählen Sie etwas aus!" }]}
                name="wheels_stored"
                label="Reifen eingelagert?"
              >
                <Select
                  size="large"
                  options={[
                    {
                      label: <span>ja</span>,
                      value: true,
                    },
                    {
                      label: <span>nein</span>,
                      value: false,
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item
                style={{ width: "100%" }}
                // rules={[{ required: true, message: "Wählen Sie etwas aus!" }]}
                name="seasonal_check"
                label="Saisonprüfung?"
              >
                <Select
                  size="large"
                  options={[
                    {
                      label: <span>keine Überprüfung</span>,
                      value: "no_check",
                    },
                    {
                      label: <span>Winterprüfung</span>,
                      value: "winter_check",
                    },
                    {
                      label: <span>Neujahrprüfung</span>,
                      value: "early_check",
                    },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="timepickers">
              <Form.Item
                style={{ width: "100%" }}
                name="shelf_number"
                label="Regalnummer"
              >
                <Input />
              </Form.Item>

              <Form.Item
                style={{ width: "100%" }}
                name="additional_services"
                label="Dienste"
              >
                <Input />
              </Form.Item>
            </div>
            <div className="timepickers">
              <Form.Item style={{ width: "100%" }} name="note" label="Notizen">
                <TextArea rows={3} />
              </Form.Item>
            </div>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default BookSlot;
